import { Identifiable, Planzone, PlanzoneSettings } from "@planzone/dto";
import { HttpClient, HttpMethods } from "@planzone/services";

function updatePlanzoneSettings(httpClient: HttpClient) {
  return (
    { uuid }: Identifiable<Planzone>,
    settings: PlanzoneSettings,
    nextSettings: { [key: string]: string },
  ) =>
    httpClient.sendHttpRequest<void>({
      endpoint: `/planzones/${uuid}`,
      method: HttpMethods.PATCH,
      data: { settings: nextSettings },
    });
}

export { updatePlanzoneSettings };
